import HomePage from '../../containers/home';
import CompaniesDictionaryContainer from '../../containers/dictionaries/companies';
import UsersRolesContainer from '../../containers/users-roles';
import UsersContainer from '../../containers/users';
import ReqsCargoContainer from '../../containers/reqs-cargo';
import EmailVerifyContainer from '../../containers/email-verify';
import { CompanyValidate } from '../../containers/company-validate';
import { CompanyAccredited } from '../../containers/company-accredited';
import RelationshipContainer from '../../containers/relationship';
import { AcceptTerms } from '../../containers/accept-terms';
import ClaimsContainer from '../../containers/claims';
import TransportsContainer from '../../containers/transports';
import AccreditationCompanyModal from '../../containers/accreditation-company';
import RelationshipSettingsContainer from '../../containers/relationship-settings';
import OrdersContainer from '../../containers/orders';
import OrderGroupsContainer from '../../containers/orders-groups';
import { NotDigital } from '../../containers/not-digital';
import OrderImportsContainer from '../../containers/orders-imports';
import OrderPlanningsContainer from '../../containers/orders-plannings';
import AutoparksContainer from '../../containers/autoparks';
import IcepacksContainer from '../../containers/icepacks';
import IcepacksFillersContainer from '../../containers/icepacks-fillers';
import IcepacksStatesContainer from '../../containers/icepacks-states';
import IcepacksFilledContainer from '../../containers/icepacks-filled';
import ThermoboxesContainer from '../../containers/thermoboxes';
import ThermoboxesReportsContainer from '../../containers/thermoboxes-reports';

export const unprotectedPageList = {
	emailVerify: {
		id: 'email-verify-page',
		path: '/email/verify/:id/:hash',
		title: 'Home',
		component: EmailVerifyContainer,
		exact: false,
	},
	emailVerifyForm: {
		id: 'email-verify-form',
		path: '/email/verify',
		title: 'Home',
		component: EmailVerifyContainer,
		exact: false,
	},
	companyValidateForm: {
		id: 'company-validate-form',
		path: '/company/validate',
		title: 'Home',
		component: CompanyValidate,
		exact: false,
	},
	companyAccreditedForm: {
		id: 'company-accredited-form',
		path: '/company/accredited',
		title: 'Home',
		component: CompanyAccredited,
		exact: false,
	},
	acceptTerms: {
		id: 'accept-terms-form',
		path: '/accept-terms',
		title: 'Home',
		component: AcceptTerms,
		exact: false,
	},
	companyAccreditation: {
		id: 'company-accreditation-form',
		path: '/company-accreditation',
		title: 'Home',
		component: AccreditationCompanyModal,
		exact: false,
	},
};

export const protectedPageList = {
	homePage: {
		id: 'home-page',
		path: '/home',
		title: 'Home',
		component: HomePage,
		exact: false,
	},
	reqsPage: {
		id: 'reqs-page',
		path: '/reqs',
		title: 'Reqs',
		component: ReqsCargoContainer,
		exact: false,
	},
	companiesDictionary: {
		id: 'companies-dictionary',
		path: '/companies',
		title: 'Companies',
		component: CompaniesDictionaryContainer,
		exact: false,
	},
	usersRoles: {
		id: 'users-roles',
		path: '/users_roles',
		title: 'UsersRoles',
		component: UsersRolesContainer,
		exact: false,
	},
	users: {
		id: 'users',
		path: '/users',
		title: 'Users',
		component: UsersContainer,
		exact: false,
	},
	relationship: {
		id: 'relationship',
		path: '/companies_relationship',
		title: 'Relationship',
		component: RelationshipContainer,
		exact: false,
	},
	claims: {
		id: 'reqs_claims',
		path: '/claims',
		title: 'Claims',
		component: ClaimsContainer,
		exact: false,
	},
	transports: {
		id: 'transports',
		path: '/quality_block',
		title: 'Transport',
		component: TransportsContainer,
		exact: false,
	},
	relationshipSettings: {
		id: 'relationship_settings',
		path: '/relationship_settings',
		title: 'RelationshipSettings',
		component: RelationshipSettingsContainer,
		exact: false,
	},
	orders: {
		id: 'orders',
		path: '/orders',
		title: 'Orders',
		component: OrdersContainer,
		exact: false,
	},
	ordersDraft: {
		id: 'orders_draft',
		path: '/orders_draft',
		title: 'Orders Draft',
		component: OrdersContainer,
		exact: false,
	},
	ordersGroups: {
		id: 'orders_groups',
		path: '/orders_groups',
		title: 'Orders Groups',
		component: OrderGroupsContainer,
		exact: false,
	},
	ordersImports: {
		id: 'orders_imports',
		path: '/orders_imports',
		title: 'Orders Imports',
		component: OrderImportsContainer,
		exact: false,
	},
	ordersPlannings: {
		id: 'orders_groups_plannings',
		path: '/orders_groups_plannings',
		title: 'Orders Plannings',
		component: OrderPlanningsContainer,
		exact: false,
	},
	autoparks: {
		id: 'orders_groups_autoparks',
		path: '/orders_groups_autoparks',
		title: 'Autoparks',
		component: AutoparksContainer,
		exact: false,
	},
	thermoboxesReports: {
		id: 'thermoboxes_reports',
		path: '/thermoboxes_reports',
		title: 'ThermoboxesReports',
		component: ThermoboxesReportsContainer,
		exact: false,
	},
	thermoboxes: {
		id: 'thermoboxes',
		path: '/thermoboxes',
		title: 'Thermoboxes',
		component: ThermoboxesContainer,
		exact: false,
	},
	icepacks: {
		id: 'icepacks',
		path: '/icepacks',
		title: 'Icepacks',
		component: IcepacksContainer,
		exact: false,
	},
	icepacksFillers: {
		id: 'icepacks_fillers',
		path: '/icepacks_fillers',
		title: 'IcepacksFillers',
		component: IcepacksFillersContainer,
		exact: false,
	},
	icepacksStates: {
		id: 'icepacks_states',
		path: '/icepacks_states',
		title: 'IcepacksStates',
		component: IcepacksStatesContainer,
		exact: false,
	},
	icepacksFilled: {
		id: 'icepacks_filled',
		path: '/icepacks_filled',
		title: 'IcepacksFilled',
		component: IcepacksFilledContainer,
		exact: false,
	},
	notDigital: {
		id: 'not_digital',
		path: '/not_digital',
		title: 'Not Digital',
		component: NotDigital,
		exact: false,
	},
};
